export type ViceAssignee = {
  name: string
  email: string
}

export const VICE_POC_ASSIGNEES: ViceAssignee[] = [
  { name: 'Juwan Campbell', email: 'jcampbell@metaphase.tech' },
  { name: 'Brian Funk', email: 'bfunk@metaphase.tech' },
  { name: 'Erik Hosler', email: 'ehosler@metaphase.tech' },
  { name: 'Magnus DiStefano', email: 'mdistefano@metaphase.tech' },
  { name: 'Lyn Schiffman', email: 'slyn@metaphase.tech' },
  { name: 'Kristin Geisz', email: 'kgeisz@metaphase.tech' },
]

export function assigneeNameForEmail(email: string | null | undefined) {
  if (!email) return null
  return VICE_POC_ASSIGNEES.find((assignee) => assignee.email === email)?.name ?? null
}
